import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";
import InputSelect from "../../../../Component/DigitalMarketing/Forms/InputSelect";
import TextArea from "../../../../Component/DigitalMarketing/Forms/TextArea";

export const headCells = [
  {
    id: "Tip_Title",
    numeric: false,
    disablePadding: true,
    label: "Tip Title",
  },
  {
    id: "name",
    numeric: true,
    disablePadding: false,
    label: "Tip Description",
  },
  {
    id: "Image",
    numeric: true,
    disablePadding: false,
    label: "Image",
  },
  {
    id: "Category_Chosen",
    numeric: true,
    disablePadding: false,
    label: "Category Chosen",
  },
  {
    id: "Scheduled_Date",
    numeric: true,
    disablePadding: false,
    label: "Scheduled Date",
  },
  {
    id: "Action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];
export const Source = [
  { id: "facebook", name: "Facebook" },
  { id: "instagram", name: "Instagram" },
  { id: "google", name: "Google" },
  { id: "twitter", name: "Twitter" },
  { id: "linkedin", name: "Linkedin" },
  { id: "youtube", name: "Youtube" },
  { id: "qrcode", name: "Qrcode" },
];
export const status = [
  { id: 1, status: "Active" },
  { id: 2, status: "Inactive" },
];
export const SourceOption = [
  { id: 1, status: "Active" },
  { id: 2, status: "Inactive" },
];
export const TipsLabel = [
  {
    tag: "branchName",
    type: "select",
    label: "branchName",
    name: "branchName",
  },
  {
    tag: InputBox,
    label: "Tip Title",
    type: "text",
    placeholder: "Enter title",
    key_name: "tipsTitle",
    required: true,
    mandatory: true,
    validation: "required",
  },
  {
    tag: TextArea,
    label: "Tip Description",
    placeholder: "Enter description",
    key_name: "tipsDescription",
    required: true,
    mandatory: true,
    validation: "required",
  },
  {
    tag: InputBox,
    label: "Upload Image",
    type: "file",
    key_name: "wellnessImage",
    required: true,
    mandatory: false,
    validation: "wellnessImage",
  },
  {
    tag: InputSelect,
    label: "Category",
    end_point: "category",
    key_name: "categoryId",
    ids: "id",
    list_name: "categoryName",
    validation: "required",
    required: true,
    mandatory: true,
  },
  {
    tag: InputBox,
    label: "Schedule Date",
    type: "date",
    key_name: "scheduleDate",
    required: true,
    mandatory: true,
    validation: "required",
  },
];
export const CategoryLabel = [
  {
    tag: InputBox,
    label: "Category Name",
    type: "text",
    key_name: "categoryName",
    placeholder: "Enter category name",
    validation: "required",
    required: true,
    mandatory: true,
  },
];
